import confetti from 'canvas-confetti';

// 🎉 Standard celebration
export const fireConfetti = () => {
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
    zIndex: 9999,
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
    colors: ['#3B82F6', '#10B981', '#F59E0B'],
  });

  fire(0.2, {
    spread: 60,
    colors: ['#3B82F6', '#10B981'],
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
    colors: ['#F59E0B', '#EF4444', '#8B5CF6'],
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
    colors: ['#10B981', '#3B82F6'],
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
    colors: ['#F59E0B', '#EF4444'],
  });
};

// 🌟 Premium gold celebration
export const fireGoldConfetti = () => {
  const duration = 3000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  const interval = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      colors: ['#FFD700', '#FFA500', '#FF8C00', '#FFFFFF'],
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      colors: ['#FFD700', '#FFA500', '#FF8C00', '#FFFFFF'],
    });
  }, 250);
};

// 🐕 Dog/Cat paw celebration (emoji confetti)
export const firePawConfetti = () => {
  const scalar = 2;
  const paw = confetti.shapeFromText({ text: '🐾', scalar });
  const heart = confetti.shapeFromText({ text: '❤️', scalar });
  const star = confetti.shapeFromText({ text: '⭐', scalar });

  const defaults = {
    spread: 360,
    ticks: 60,
    gravity: 0.5,
    decay: 0.96,
    startVelocity: 20,
    shapes: [paw, heart, star],
    scalar,
    zIndex: 9999,
  };

  function shoot() {
    confetti({
      ...defaults,
      particleCount: 30,
    });

    confetti({
      ...defaults,
      particleCount: 5,
      flat: true,
    });

    confetti({
      ...defaults,
      particleCount: 15,
      scalar: scalar / 2,
      shapes: ['circle'],
      colors: ['#3B82F6', '#10B981', '#F59E0B'],
    });
  }

  setTimeout(shoot, 0);
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);
};

// 🚀 Side cannons
export const fireSideCannons = () => {
  const end = Date.now() + 1000;
  const colors = ['#3B82F6', '#10B981', '#F59E0B', '#8B5CF6'];

  (function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors,
      zIndex: 9999,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors,
      zIndex: 9999,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  }());
};
